import React from "react";
import { withRouter, Switch, Route } from "react-router-dom";
import { inject, observer } from "mobx-react";
import Header from "./header/header";
import User from "./user/user";
import Navigation from "./navigation/navigation";
import ControlCenter from "./controlCenter/controlCenter";
import RegistrationCenter from "./registrationCenter/registrationCenter";
import CreateTeam from "./createTeam/createTeam";
import TeamInfoEdit from "./createTeam/teamInfoEdit";
import ApplyTeamSuccess from "./applyTeam/applyTeamSuccess";
import CreateTeamSuccess from "./createTeam/createTeamSuccess";
import GameApplyInfo from "./controlCenter/gameApply/index";
import GameApplyPerson from "./controlCenter/gameApplyPerson";
import Messages from "./message/message";
import MessageCenter from "./message/messageCenter";
import GameComplete from "./game/gameComplete";
import Modal from "./modal/modal";
import Language from "./language/language";
import PersonInfoNotice from "./registrationCenter/personInfoNotice";
import { $util } from "../helper";
import Track from "../lego/columbus";
import qs from "query-string";
import agent from "../agent";
import PerfTrack from "../lego/perfTrack";
import Gtag from "../lego/gTag";
import Footer from "./footer/index";

import "../stylesheets/common.scss";
import "../stylesheets/antd-theme.scss";

@inject("commonStore", "languageStore", "authStore", "navStore")
@withRouter
@observer
export default class App extends React.Component {
  componentWillMount() {
    if (
      this.props.history.location.pathname === "/" ||
      this.props.history.location.pathname === "/registration"
    ) {
      this.props.history.push("/registration-center");
    }
  }

  getDomainLocale = lang => {
    return lang === "zh" ? "zh-CN" : "en-US";
  };

  componentDidMount() {
    const parsed = qs.parse(this.props.history.location.search);
    if (parsed && localStorage) {
      if (parsed.djiFrom) {
        localStorage.setItem("djiFrom", parsed.djiFrom);
      }
      if (parsed.isSummer) {
        localStorage.setItem("isSummer", 1);
      }
    }
    const pathname = this.props.history.location.pathname;
    if (pathname.indexOf("registration") > 0) {
      this.props.navStore.changeNavigation("/registration-center");
    } else if (pathname.indexOf("message-center") > 0) {
      this.props.navStore.changeNavigation("/message-center");
    } else {
      this.props.navStore.changeNavigation("/control-center");
    }
    this.props.authStore.pullUser().finally(() => {
      if (!this.props.authStore.user || !this.props.authStore.user.id) {
        if (process.env.NODE_ENV !== "development") {
          window.location.href = $util.getLoginUrl(this.props.languageStore.lang);
        }
      }
      this.initGATrack();
    });
    this.initTrack();
    this.initPerfTrack();
  }

  /**
   * 初始化GA4埋点收集
   */
  initGATrack() {
    const userId = (this.props.authStore.user && this.props.authStore.user.id) || "none";
    const gTag = Gtag(userId);
    this.props.commonStore.setGTag(gTag);
  }

  /**
   *  初始化自定义埋点收集。
   */
  initTrack() {
    const track = new Track({
      id: "root",
      systemId: "101",
      callback: data => {
        // 上报埋点
        agent.SassPlatform.report(data);
      }
    });
    this.props.commonStore.setTrackReport(track);
  }

  /**
   * 初始化性能统计。
   * baseGaCategory: 用于区分版本，评估优化效果。
   */
  initPerfTrack() {
    new PerfTrack({
      baseGaCategory: "perf-track-2.3",
      baseGa4Category: "perfTrack2.3"
    });
  }

  render() {
    if (!this.props.authStore.user || !this.props.authStore.user.id) {
      return null;
    }
    return (
      <div
        id="app"
        data-log={$util.log({
          userId: this.props.authStore.user.id
        })}
      >
        <Header />
        <div className="page-module">
          <User />
          <Navigation />
          <div className="module-content">
            <Switch>
              <Route path="/control-center" component={ControlCenter} />
              <Route path="/registration-center" component={RegistrationCenter} />
              <Route path="/create-team" component={CreateTeam} />
              <Route path="/apply-team-success" component={ApplyTeamSuccess} />
              <Route path="/create-team-success" component={CreateTeamSuccess} />
              <Route path="/team-apply/:id?" component={GameApplyInfo} />
              <Route path="/game-apply-info/:id" component={GameApplyInfo} />
              <Route path="/personGame-apply-info/:id" component={GameApplyPerson} />
              <Route path="/team-info-edit/:id?" component={TeamInfoEdit} />
              <Route path="/game-complete" component={GameComplete} />
              <Route path="/message-center" component={MessageCenter} />
            </Switch>
          </div>
        </div>
        <Footer />
        <Messages />
        <Modal
          width={457}
          title={<Language resource="PERSON_INFO_NOT_COMPLETE" />}
          state={this.props.authStore.oldUserNeedVaild}
        >
          <PersonInfoNotice />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js